import React, { useEffect, useMemo, useState } from 'react';
import { fetchHardCrabCalendarAP } from '../services/api';

/**
 * Reports > Hard Crab Calendar (AP): the admin portal month calendar, bushels sold each day by size
 * (Azure exit WS8). Built beside Hard Crab Calendar, which counts orders by steamed date.
 */

const SIZES = [
  ['premiumMales', 'Premium'], ['standardMales', 'Standard'], ['colossalMales', 'Colossal'],
  ['selectMales', 'Select'], ['regularFemales', 'Regular F'], ['largeFemales', 'Large F'],
];
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const monthNow = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; };

export default function HardCrabCalendarAP() {
  const [month, setMonth] = useState(monthNow());
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setRows(null);
    setError(null);
    fetchHardCrabCalendarAP(month)
      .then((r) => { if (live) setRows(r); })
      .catch((e) => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [month]);

  const weeks = useMemo(() => {
    const [y, m] = month.split('-').map(Number);
    const cells = Array(new Date(y, m - 1, 1).getDay()).fill(null);
    const last = new Date(y, m, 0).getDate();
    for (let d = 1; d <= last; d += 1) cells.push({ day: d, ...(rows || []).find((r) => r.day === d) });
    while (cells.length % 7) cells.push(null);
    const out = [];
    for (let i = 0; i < cells.length; i += 7) out.push(cells.slice(i, i + 7));
    return out;
  }, [month, rows]);

  return (
    <div>
      <div className="page-header">
        <h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--navy)', margin: 0 }}>Hard Crab Calendar (AP)</h2>
      </div>
      <div className="port-filters">
        <input type="month" className="form-input" style={{ width: 'auto' }} value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} />
      </div>
      <div className="card">
        {error && <div style={{ padding: 16, fontSize: 12, color: 'var(--red)' }}>Error: {error}</div>}
        {!rows && !error && <div style={{ padding: 16, fontSize: 12, color: 'var(--gray-500)' }}>Loading...</div>}
        {rows && (
          <div className="port-scroll">
            <table className="trans-table">
              <thead><tr>{DAYS.map((d) => <th key={d}>{d}</th>)}</tr></thead>
              <tbody>
                {weeks.map((w, i) => (
                  <tr key={i}>
                    {w.map((c, j) => (
                      <td key={j} style={{ verticalAlign: 'top', minWidth: 90 }}>
                        {c && <div style={{ fontWeight: 700 }}>{c.day}</div>}
                        {c && SIZES.map(([k, label]) => (Number(c[k]) > 0 ? <div key={k}>{label}: {Number(c[k]).toFixed(2)}</div> : null))}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}